import React from 'react';
import InlineTooltip from '../Tooltip/InlineTooltip';

const InputNumber = ({ value, id, label, handleChange, error, helpText, mandatory }) => {
  return (
    <div className='mb-4' dzt-field-id={id}>
      {label && (
        <label
          htmlFor={id}
          className="block text-xs font-semibold uppercase tracking-wider text-stride-muted mb-1.5 flex items-center gap-1.5"
        >
          <span>
            {label} {mandatory && <span className="text-stride-danger">*</span>}
          </span>
          {helpText && (
            <InlineTooltip
              content={helpText}
              imgClass="pt-0.5"
            />
          )}
        </label>
      )}
      <input
        type="number"
        id={id}
        name={id}
        className="w-full h-10 px-3.5 text-sm font-medium text-stride-heading bg-white rounded-lg border border-stride-border focus:border-stride-primary focus:ring-1 focus:ring-stride-primary focus:outline-none transition-all placeholder:text-stride-muted disabled:bg-stride-bg disabled:text-stride-muted"
        placeholder={label}
        value={value}
        onChange={handleChange}
      />
      {error && <p className="mt-1.5 text-xs text-stride-danger font-medium">{error}</p>}
    </div>
  );
};

export default InputNumber;
